import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fapiaoAddressList__content" }
const _hoisted_2 = { class: "fl-left" }
const _hoisted_3 = { class: "fl-right" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("确定要 "),
  /*#__PURE__*/_createElementVNode("b", null, "删除"),
  /*#__PURE__*/_createTextVNode(" 收货地址?")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-error"
}, "删除", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_address_editor_modal = _resolveComponent("address-editor-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "utils__pageContainer fapiaoAddressList",
    title: "收货地址管理"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          class: "fl-clean fapiaoAddressList__controls",
          form: _ctx.filterParams
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onCreateItem
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增收货地址")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_button, {
                type: "primary",
                ghost: "",
                onClick: _ctx.onRefreshTable
              }, {
                default: _withCtx(() => [
                  _createTextVNode("刷新")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          "show-pagination": true,
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.onEditItem(record)), ["prevent"])
            }, "编辑", 8, _hoisted_4),
            _hoisted_5,
            _createVNode(_component_a_popconfirm, {
              placement: "top",
              onConfirm: ($event: any) => (_ctx.onDelItem(record))
            }, {
              title: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onConfirm"])
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ]),
      _createVNode(_component_address_editor_modal, {
        ref: "editorRef",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onComplete"])
    ]),
    _: 1
  }))
}